import { render } from "./PayPal.vue?vue&type=template&id=29b6404a&scoped=true"
import script from "./PayPal.vue?vue&type=script&lang=js"
export * from "./PayPal.vue?vue&type=script&lang=js"

import "./PayPal.vue?vue&type=style&index=0&id=29b6404a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29b6404a"

export default script